/*
 * Verify Email
 * decodes email and request put to complete verification
 */

module.controller('verifyEmailCtrl', ['$scope', '$state', '$http', '$stateParams', 'baseURI', 'Transform', 'base64',
  function ($scope, $state, $http, $stateParams, baseURI, Transform, base64){

    //decode base64
    var decodeData = function(data){
      try {
        var decoded = base64.decode(data);
        req = JSON.parse(decoded);
        req._key = $scope.brand.api_key;
        verifyEmail(req);
      } catch(e){
        $scope.loading = false;
        $scope.successVerification = false;
      }
    };

    // make PUT
    var verifyEmail = function(req){
      $scope.loading = true;

      $http({
        method: 'PUT',
        url: baseURI + 'email/verification',
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
        data: Transform.encode(req)
      }).then(function(resp){
        var data = resp.data;

        // Close the tab
        $scope.loading = false;
        $scope.successVerification = data.Success;
      }).catch(function (error){
        $scope.loading = false;
        $scope.successVerification = false;
      });
    };

    decodeData($stateParams.data);

  }]);
